import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import React from "react";
import { makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";

import { sendPasswordResetLink } from "../../store/auth-slice";
import { updateUser } from "../../store/users-slice";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(2, 0, 1, 0),
    width: 200,
  },
  formControlSwitch: {
    margin: theme.spacing(2, 3, 1, 3),
    width: 200,
  },
}));

const UserEdit = (props) => {
  const [email, setEmail] = React.useState("");
  const [isEmailCorrect, setIsEmailCorrect] = React.useState(true);
  const [login, setLogin] = React.useState("");
  const [role, setRole] = React.useState("");
  const [isActive, setIsActive] = React.useState(false);

  const dispatch = useDispatch();

  const classes = useStyles();

  React.useEffect(() => {
    setEmail(props.user?.email);
    setIsEmailCorrect(true);
    setLogin(props.user?.login);
    setRole(props.user?.role);
    setIsActive(props.user?.isActive);
  }, [props]);

  const closeHandler = () => {
    setIsEmailCorrect(true);
    props.onClose();
  };

  const saveButtonClickHandler = async (_) => {
    dispatch(
      updateUser({
        email,
        login,
        role,
        isActive,
      })
    );

    props.onClose();
  };

  const passwordResetClickHandler = async (_) => {
    dispatch(sendPasswordResetLink(email));
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.close}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Edit user</DialogTitle>
      <DialogContent>
        <TextField
          error={!isEmailCorrect}
          helperText={!isEmailCorrect ? "Incorrect email" : null}
          autoFocus
          margin="dense"
          id="customerEmail"
          label="Email Address"
          type="email"
          fullWidth
          aria-readonly
          InputProps={{
            readOnly: true,
          }}
          //onBlur={emailBlurHandler}
          value={email}
          //onChange={(event) => setEmail(event.target.value)}
        />
        <TextField
          margin="dense"
          id="login"
          label="Login"
          type="text"
          fullWidth
          value={login}
          onChange={(event) => setLogin(event.target.value)}
        />
        <FormControl className={classes.formControl}>
          <InputLabel id="role-label">Role</InputLabel>
          <Select
            fullWidth
            margin="dense"
            labelId="role-label"
            id="role"
            value={role}
            onChange={(event) => setRole(event.target.value)}
          >
            <MenuItem value="Customer">Customer</MenuItem>
            <MenuItem value="Administrator">Administrator</MenuItem>
            <MenuItem value="Reader">Reader</MenuItem>
          </Select>
        </FormControl>
        <FormControlLabel
          className={classes.formControlSwitch}
          control={
            <Switch
              color="primary"
              checked={isActive}
              onChange={() => setIsActive((active) => !active)}
            />
          }
          label="Active"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={passwordResetClickHandler} color="secondary">
          Password reset
        </Button>
        <Button onClick={closeHandler} color="primary">
          Cancel
        </Button>
        <Button
          onClick={saveButtonClickHandler}
          color="primary"
          disabled={login === "" || role === ""}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default UserEdit;
